import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  Row,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  FormGroup,
  Modal,
  ModalBody,
} from "reactstrap";
import { connect } from "react-redux";
import { registerUser } from "../../redux/actions";
import { Colxx } from "../../components/common/CustomBootstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { NotificatioErrController } from "../../helpers/Utils";
import { END_POINT } from "../../constants/defaultValues";
import axios from "axios";
import { Validator } from "../../helpers/Validator";

// <<< TẠO MỘT MẢNG CÁC LỰA CHỌN CHO DỄ QUẢN LÝ
const businessTypeOptions = [
  { value: "", label: "Vui lòng chọn lĩnh vực kinh doanh" },
  { value: "cafe", label: "Quán cà phê, trà sữa, trà chanh" },
  { value: "restaurant", label: "Nhà hàng, quán ăn" },
  { value: "grocery", label: "Tạp hóa, siêu thị mini" },
  { value: "pharmacy", label: "Nhà thuốc, dược phẩm" },
  { value: "electronics", label: "Điện máy, công nghệ" },
  { value: "spa", label: "Spa, thẩm mỹ viện, salon" },
  { value: "fashion", label: "Thời trang" },
  { value: "cosmetics", label: "Mỹ phẩm" },
  { value: "retail", label: "Bán lẻ khác" },
];

const Register = (props) => {
  /* ============================================================
       OTP LOGIC - TEMPORARILY COMMENTED OUT
       Uncomment when brandname registration is complete
    ============================================================ */
  // // Step state: 1 = Phone verification, 2 = Registration form
  // const [currentStep, setCurrentStep] = useState(1);
  //
  // // OTP States
  // const [otpPhone, setOtpPhone] = useState('');
  // const [otpCode, setOtpCode] = useState('');
  // const [otpSent, setOtpSent] = useState(false);
  // const [otpLoading, setOtpLoading] = useState(false);
  // const [otpVerifying, setOtpVerifying] = useState(false);
  // const [otpCountdown, setOtpCountdown] = useState(0);
  // const [verificationToken, setVerificationToken] = useState('');
  //
  // // OTP Countdown Effect
  // useEffect(() => {
  //     if (otpCountdown > 0) {
  //         const timer = setTimeout(() => {
  //             setOtpCountdown(otpCountdown - 1);
  //         }, 1000);
  //         return () => clearTimeout(timer);
  //     }
  // }, [otpCountdown]);
  //
  // // Send OTP function
  // const handleSendOTP = async () => {
  //     // Validate phone
  //     const phoneRegex = /^(0|\+84|84)?[3|5|7|8|9][0-9]{8}$/;
  //     if (!otpPhone || !phoneRegex.test(otpPhone.replace(/\s/g, ''))) {
  //         NotificatioErrController('Vui lòng nhập số điện thoại hợp lệ (VD: 0901234567)');
  //         return;
  //     }
  //
  //     setOtpLoading(true);
  //     try {
  //         const response = await axios.post(`${END_POINT}/otp/send`, {
  //             phone: otpPhone,
  //         });
  //
  //         if (response.data.success) {
  //             setOtpSent(true);
  //             setOtpCountdown(60); // 60 seconds cooldown
  //             NotificatioSucController(response.data.message);
  //         } else {
  //             NotificatioErrController(response.data.message);
  //         }
  //     } catch (error) {
  //         const errorMsg = error.response?.data?.message || 'Có lỗi xảy ra khi gửi OTP';
  //         NotificatioErrController(errorMsg);
  //
  //         // If cooldown error, set remaining seconds
  //         if (error.response?.data?.remainingSeconds) {
  //             setOtpCountdown(error.response.data.remainingSeconds);
  //         }
  //     } finally {
  //         setOtpLoading(false);
  //     }
  // };
  //
  // // Verify OTP function
  // const handleVerifyOTP = async () => {
  //     if (!otpCode || otpCode.length !== 6) {
  //         NotificatioErrController('Vui lòng nhập mã OTP 6 số');
  //         return;
  //     }
  //
  //     setOtpVerifying(true);
  //     try {
  //         const response = await axios.post(`${END_POINT}/otp/verify`, {
  //             phone: otpPhone,
  //             code: otpCode,
  //         });
  //
  //         if (response.data.success) {
  //             setVerificationToken(response.data.verificationToken);
  //             setValues(prev => ({ ...prev, phone: otpPhone }));
  //             setCurrentStep(2);
  //             NotificatioSucController('Xác thực thành công! Vui lòng điền thông tin đăng ký.');
  //         } else {
  //             NotificatioErrController(response.data.message);
  //         }
  //     } catch (error) {
  //         const errorMsg = error.response?.data?.message || 'Mã OTP không đúng';
  //         NotificatioErrController(errorMsg);
  //     } finally {
  //         setOtpVerifying(false);
  //     }
  // };
  /* ============================================================
       END OTP LOGIC COMMENT
    ============================================================ */

  const [values, setValues] = useState({
    fullname: "",
    phone: "",
    email: "",
    businessType: "",
    password: "",
    domain: "",
    url: window.location.host.replace("register.", ""),
    popover: false,
    pinSuccessMessage: false,
  });

  // State cho success modal và countdown
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [storeUrl, setStoreUrl] = useState("");

  // THÊM STATE MỚI ĐỂ KIỂM TRA TÍNH DUY NHẤT CỦA DOMAIN
  const [domainAvailability, setDomainAvailability] = useState({
    status: "idle", // 'idle', 'checking', 'available', 'taken', 'error'
    message: "",
  });

  // State cho pending upgrade (từ price.vmass.vn)
  const [pendingUpgrade, setPendingUpgrade] = useState(null);

  // Đọc upgrade params từ URL khi component mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const upgradePackage = urlParams.get("upgrade");
    const upgradeDuration = urlParams.get("duration");

    if (upgradePackage && upgradeDuration) {
      const upgradeInfo = {
        package: upgradePackage,
        duration: upgradeDuration,
      };
      setPendingUpgrade(upgradeInfo);
      // Lưu vào localStorage để payment page có thể đọc
      localStorage.setItem("pendingUpgrade", JSON.stringify(upgradeInfo));
    } else {
      // Clear pending upgrade if not in URL to prevent accidental redirect
      setPendingUpgrade(null);
      localStorage.removeItem("pendingUpgrade");
    }
  }, []);

  const domainConditions = useMemo(() => {
    const rawDomain = (values.domain || "").trim().toLowerCase();
    if (!rawDomain) {
      return {
        noSpaces: false,
        isShopNameLike: false,
        onlyLowercaseAndNumbers: false,
      };
    }

    const noSpaces = !/\s/.test(rawDomain);
    const onlyLowercaseAndNumbers = /^[a-z0-9_]+$/.test(rawDomain);
    const isShopNameLike = rawDomain.length >= 5;

    return {
      noSpaces,
      isShopNameLike,
      onlyLowercaseAndNumbers: onlyLowercaseAndNumbers && noSpaces,
    };
  }, [values.domain]);

  const domainRulesReady =
    domainConditions.noSpaces &&
    domainConditions.onlyLowercaseAndNumbers &&
    domainConditions.isShopNameLike;

  // Effect để kiểm tra tính khả dụng của domain (debounce 500ms)
  useEffect(() => {
    const rawDomain = (values.domain || "").trim().toLowerCase();

    if (!rawDomain) {
      setDomainAvailability({ status: "idle", message: "" });
      return;
    }

    const noSpaces = !/\s/.test(rawDomain);
    const onlyLowercaseAndNumbers = /^[a-z0-9_]+$/.test(rawDomain);
    const isShopNameLike = rawDomain.length >= 5;

    if (!noSpaces || !onlyLowercaseAndNumbers || !isShopNameLike) {
      setDomainAvailability({ status: "idle", message: "" });
      return;
    }

    setDomainAvailability({ status: "checking", message: "Đang kiểm tra..." });

    const timer = setTimeout(async () => {
      try {
        const response = await axios.get(
          `${END_POINT}/user/check-domain-availability?domain=${encodeURIComponent(rawDomain)}`,
        );
        if (response.data && response.data.isAvailable) {
          setDomainAvailability({
            status: "available",
            message: response.data.message || "Tên miền có thể sử dụng!",
          });
        } else {
          setDomainAvailability({
            status: "taken",
            message: response.data.message || "Tên miền đã được sử dụng.",
          });
        }
      } catch (err) {
        console.error("Lỗi khi kiểm tra domain:", err.response || err.message);
        const errorMessage =
          err.response?.data?.message ||
          err.response?.data?.responseText ||
          err.response?.data?.error ||
          (err.message === "Network Error"
            ? "Không thể kết nối đến máy chủ. Vui lòng kiểm tra lại kết nối mạng."
            : "Lỗi khi kiểm tra tên miền. Vui lòng thử lại.");
        setDomainAvailability({ status: "error", message: errorMessage });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [values.domain]);

  // Validator - now runs on mount since we have single form
  useEffect(() => {
    const initializeValidators = () => {
      Validator({
        form: "#form-register",
        formGroupSelector: ".form-group",
        errorSelector: ".form-message",
        rules: [
          Validator.isRequired("#fullname"),
          Validator.isRequired("#phone"),
          Validator.isRequired("#email"),
          Validator.isRequired("#businessType"),
          Validator.isEmail("#email"),
          Validator.isRequired("#domain"),
          Validator.isCharacter("#domain"),
          Validator.minLength(
            "#domain",
            5,
            "Tên cửa hàng phải có ít nhất 5 ký tự",
          ),
          {
            selector: "#domain",
            test: (value) => {
              if (domainAvailability.status === "taken") {
                return (
                  domainAvailability.message || "Tên miền này đã được sử dụng."
                );
              }
              return undefined;
            },
          },
          Validator.isRequired("#password"),
          Validator.minLength("#password", 6),
        ],
        onSubmit: (data) => {
          console.log(data);
        },
      });
    };
    initializeValidators();
  }, [domainAvailability.status, domainAvailability.message]);

  const onUserRegister = () => {
    const normalizedDomain = (values.domain || "").trim().toLowerCase();

    if (
      !values.fullname ||
      !values.phone ||
      !values.email ||
      !values.businessType ||
      !values.password ||
      !normalizedDomain
    ) {
      NotificatioErrController("Vui lòng nhập đầy đủ các thông tin");
      return false;
    }

    if (
      !domainConditions.noSpaces ||
      !domainConditions.onlyLowercaseAndNumbers
    ) {
      NotificatioErrController(
        "Tên cửa hàng chỉ hỗ trợ chữ thường, số và dấu gạch dưới (_), viết liền không dấu",
      );
      return false;
    }

    if (!domainConditions.isShopNameLike) {
      NotificatioErrController("Tên cửa hàng phải có ít nhất 5 ký tự");
      return false;
    }

    if (domainAvailability.status === "checking") {
      NotificatioErrController("Đang kiểm tra tên cửa hàng, vui lòng đợi...");
      return false;
    }

    if (domainAvailability.status === "taken") {
      NotificatioErrController(
        domainAvailability.message ||
          "Tên cửa hàng đã được đăng ký, vui lòng chọn tên khác",
      );
      return false;
    }

    if (domainAvailability.status === "error") {
      NotificatioErrController(
        domainAvailability.message ||
          "Lỗi khi kiểm tra tên miền. Vui lòng thử lại.",
      );
      return false;
    }

    if (domainAvailability.status !== "available") {
      NotificatioErrController(
        "Tên cửa hàng chưa được kiểm tra hoặc không khả dụng. Vui lòng thử lại.",
      );
      return false;
    }

    props.registerUser(
      {
        ...values,
        domain: normalizedDomain,
      },
      props.history,
    );
  };

  const onChangeHandleInput = (e) => {
    let { value, name } = e.target;
    if (name === "domain") {
      value = value.toLowerCase().replace(/\s+/g, "");
    }
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  // Ref to track if success modal has been shown (prevents countdown reset)
  const hasShownSuccessModal = useRef(false);

  useEffect(() => {
    if (props.user && typeof props.user === "object") {
      if (props.user.status && props.user.status !== 200) {
        const errorMsg =
          props.user.data?.responseText ||
          props.user.data?.message ||
          props.user.responseText ||
          props.user.message ||
          "Có lỗi xảy ra trong quá trình đăng ký/đăng nhập";
        NotificatioErrController(errorMsg);
      }

      if (props.user.status === 200 && !hasShownSuccessModal.current) {
        hasShownSuccessModal.current = true; // Prevent running again

        const protocol = window.location.protocol;
        const baseUrl = values.url;
        const fullStoreUrl = `${protocol}//${values.domain}.${baseUrl}/app/dashboards/default`;
        setStoreUrl(fullStoreUrl);

        setShowSuccessModal(true);
        setCountdown(5);
      }
    }
  }, [props.user]);

  // Countdown effect khi modal hiển thị
  useEffect(() => {
    if (showSuccessModal && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessModal, countdown]);

  // // Hàm chuyển hướng ngay
  // const handleGoToStore = () => {
  //   if (storeUrl) {
  //     window.location.href = storeUrl;
  //   }
  // };

  const commonIconClass = "mr-2";
  const successIcon = "simple-icon-check text-success";
  const defaultIcon = "simple-icon-close text-muted";
  const errorIcon = "simple-icon-close text-danger";
  const checkingIcon = "simple-icon-refresh text-info";

  /* ============================================================
       STEP 1 RENDER - TEMPORARILY COMMENTED OUT
       Uncomment when brandname registration is complete
    ============================================================ */
  // // Render Step 1: Phone Verification
  // const renderStep1 = () => (
  //     <div className='form-side'>
  //         <a href='https://vmass.vn/' className='white'>
  //             <span className='logo-single' />
  //         </a>
  //         <CardTitle className='mb-2'>
  //             Xác thực số điện thoại
  //         </CardTitle>
  //         <p className="text-muted mb-4">
  //             Nhập số điện thoại của bạn để nhận mã xác thực OTP
  //         </p>
  //
  //         <Form>
  //             <FormGroup className={'mb-4'}>
  //                 <Label className='has-float-label'>
  //                     <Input
  //                         autoFocus={true}
  //                         onChange={(e) => setOtpPhone(e.target.value)}
  //                         type='tel'
  //                         name='phone'
  //                         id='phone-otp'
  //                         value={otpPhone}
  //                         placeholder="0901234567"
  //                         disabled={otpSent && otpCountdown > 0}
  //                     />
  //                     <span>Số điện thoại</span>
  //                 </Label>
  //             </FormGroup>
  //
  //             {!otpSent ? (
  //                 <div className='d-flex justify-content-end align-items-center'>
  //                     <Button
  //                         color='primary'
  //                         className='btn-shadow'
  //                         size='lg'
  //                         onClick={handleSendOTP}
  //                         disabled={otpLoading}
  //                     >
  //                         {otpLoading ? (
  //                             <>
  //                                 <i className="simple-icon-refresh spinning mr-2"></i>
  //                                 Đang gửi...
  //                             </>
  //                         ) : (
  //                             <>
  //                                 <i className="simple-icon-cursor mr-2"></i>
  //                                 Gửi mã OTP
  //                             </>
  //                         )}
  //                     </Button>
  //                 </div>
  //             ) : (
  //                 <>
  //                     <FormGroup className={'mb-4'}>
  //                         <Label className='has-float-label'>
  //                             <Input
  //                                 autoFocus={true}
  //                                 onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
  //                                 type='text'
  //                                 name='otp'
  //                                 id='otp-code'
  //                                 value={otpCode}
  //                                 placeholder="Nhập mã 6 số"
  //                                 maxLength={6}
  //                                 style={{
  //                                     fontSize: '24px',
  //                                     letterSpacing: '8px',
  //                                     textAlign: 'center',
  //                                     fontWeight: 'bold'
  //                                 }}
  //                             />
  //                             <span>Mã OTP</span>
  //                         </Label>
  //                         <FormText className="text-center mt-2">
  //                             {otpCountdown > 0 ? (
  //                                 <span className="text-muted">
  //                                     Gửi lại mã sau <strong>{otpCountdown}</strong> giây
  //                                 </span>
  //                             ) : (
  //                                 <Button
  //                                     color="link"
  //                                     className="p-0"
  //                                     onClick={handleSendOTP}
  //                                     disabled={otpLoading}
  //                                 >
  //                                     Gửi lại mã OTP
  //                                 </Button>
  //                             )}
  //                         </FormText>
  //                     </FormGroup>
  //
  //                     <div className='d-flex justify-content-between align-items-center'>
  //                         <Button
  //                             color='secondary'
  //                             outline
  //                             onClick={() => {
  //                                 setOtpSent(false);
  //                                 setOtpCode('');
  //                             }}
  //                         >
  //                             <i className="simple-icon-arrow-left mr-2"></i>
  //                             Đổi số
  //                         </Button>
  //                         <Button
  //                             color='primary'
  //                             className='btn-shadow'
  //                             size='lg'
  //                             onClick={handleVerifyOTP}
  //                             disabled={otpVerifying || otpCode.length !== 6}
  //                         >
  //                             {otpVerifying ? (
  //                                 <>
  //                                     <i className="simple-icon-refresh spinning mr-2"></i>
  //                                     Đang xác thực...
  //                                 </>
  //                             ) : (
  //                                 <>
  //                                     <i className="simple-icon-check mr-2"></i>
  //                                     Xác thực
  //                                 </>
  //                             )}
  //                         </Button>
  //                     </div>
  //                 </>
  //             )}
  //         </Form>
  //
  //         {/* Step indicator */}
  //         <div className="text-center mt-4">
  //             <div className="d-flex justify-content-center align-items-center">
  //                 <div
  //                     className="rounded-circle d-flex align-items-center justify-content-center"
  //                     style={{
  //                         width: 32,
  //                         height: 32,
  //                         backgroundColor: '#007bff',
  //                         color: 'white',
  //                         fontWeight: 'bold'
  //                     }}
  //                 >
  //                     1
  //                 </div>
  //                 <div
  //                     style={{
  //                         width: 60,
  //                         height: 3,
  //                         backgroundColor: '#dee2e6'
  //                     }}
  //                 ></div>
  //                 <div
  //                     className="rounded-circle d-flex align-items-center justify-content-center"
  //                     style={{
  //                         width: 32,
  //                         height: 32,
  //                         backgroundColor: '#dee2e6',
  //                         color: '#6c757d',
  //                         fontWeight: 'bold'
  //                     }}
  //                 >
  //                     2
  //                 </div>
  //             </div>
  //             <small className="text-muted mt-3 d-block">
  //                 Bước 1: Xác thực số điện thoại
  //             </small>
  //         </div>
  //     </div>
  // );
  /* ============================================================
       END STEP 1 RENDER COMMENT
    ============================================================ */

  // Render Registration Form (Single Form - no steps)
  const renderRegistrationForm = () => (
    <div className="form-side">
      <a href="https://vmass.vn/" className="white">
        <span
          className="logo-single"
          style={{
            backgroundImage: `url('${process.env.PUBLIC_URL}/assets/img/logo-black.svg')`,
          }}
        />
      </a>
      <CardTitle className="mb-4">
        <IntlMessages id="user.register" />
      </CardTitle>

      <Form id="form-register">
        <FormGroup className={"mb-4"}>
          <Label className="has-float-label">
            <Input
              autoFocus={true}
              onChange={onChangeHandleInput}
              type="text"
              name="fullname"
              id="fullname"
              defaultValue={values.fullname}
            />
            <IntlMessages id="user.fullname" />
          </Label>
          <span className="form-message"></span>
        </FormGroup>
        <FormGroup className={"mb-4"}>
          <Label className="has-float-label">
            <Input
              onChange={onChangeHandleInput}
              type="tel"
              name="phone"
              id="phone"
              placeholder="0901234567"
              defaultValue={values.phone}
            />
            <IntlMessages id="user.phone" />
          </Label>
          <span className="form-message"></span>
        </FormGroup>
        <FormGroup className={"mb-4"}>
          <Label className="has-float-label">
            <Input
              onChange={onChangeHandleInput}
              type="email"
              name="email"
              id="email"
              defaultValue={values.email}
            />
            <IntlMessages id="user.email" />
          </Label>
          <span className="form-message"></span>
        </FormGroup>
        <FormGroup className="mb-4">
          <Label for="businessType" className="has-float-label">
            Lĩnh vực kinh doanh
          </Label>
          <Input
            type="select"
            name="businessType"
            id="businessType"
            value={values.businessType}
            onChange={onChangeHandleInput}
          >
            {businessTypeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
          <span className="form-message"></span>
        </FormGroup>
        <Row>
          <Colxx xxs="6" className="username">
            <FormGroup className="mb-0">
              <Label className="has-float-label mb-1">
                <Input
                  className="form-control text-end"
                  onChange={onChangeHandleInput}
                  type="text"
                  name="domain"
                  id="domain"
                  value={values.domain}
                />
                <IntlMessages id="user.username" />
              </Label>
              <span className="form-message"></span>
            </FormGroup>
          </Colxx>
          <span className="domain">{`.${values.url}`}</span>
        </Row>
        <Row className="mt-2">
          <Colxx xxs="12">
            <div
              className={`text-small mt-1 ${
                domainConditions.noSpaces &&
                domainConditions.onlyLowercaseAndNumbers
                  ? "text-success"
                  : "text-muted"
              }`}
            >
              <i
                className={`${commonIconClass} ${
                  domainConditions.noSpaces &&
                  domainConditions.onlyLowercaseAndNumbers
                    ? successIcon
                    : defaultIcon
                }`}
              />
              Viết liền không dấu
            </div>
          </Colxx>
          <Colxx xxs="12">
            <div
              className={`text-small mt-1 ${
                domainConditions.onlyLowercaseAndNumbers
                  ? "text-success"
                  : "text-muted"
              }`}
            >
              <i
                className={`${commonIconClass} ${
                  domainConditions.onlyLowercaseAndNumbers
                    ? successIcon
                    : defaultIcon
                }`}
              />
              Chỉ bao gồm chữ thường và số
            </div>
          </Colxx>
          <Colxx xxs="12">
            <div
              className={`text-small mt-1 ${
                domainConditions.isShopNameLike ? "text-success" : "text-muted"
              }`}
            >
              <i
                className={`${commonIconClass} ${
                  domainConditions.isShopNameLike ? successIcon : defaultIcon
                }`}
              />
              Là tên cửa hàng của bạn. Tối thiểu 5 ký tự
            </div>
          </Colxx>
          <Colxx xxs="12">
            <div
              className={`text-small mt-1 ${
                domainAvailability.status === "available" && domainRulesReady
                  ? "text-success"
                  : domainAvailability.status === "taken" ||
                      domainAvailability.status === "error"
                    ? "text-danger"
                    : domainAvailability.status === "checking"
                      ? "text-info"
                      : "text-muted"
              }`}
            >
              <i
                className={`${commonIconClass} ${
                  domainAvailability.status === "available" && domainRulesReady
                    ? successIcon
                    : domainAvailability.status === "taken" ||
                        domainAvailability.status === "error"
                      ? errorIcon
                      : domainAvailability.status === "checking"
                        ? checkingIcon
                        : defaultIcon
                }`}
              />
              {domainAvailability.status === "checking"
                ? "Đang kiểm tra..."
                : domainAvailability.status === "available" && domainRulesReady
                  ? domainAvailability.message || "Tên miền có thể sử dụng!"
                  : domainAvailability.status === "taken" ||
                      domainAvailability.status === "error"
                    ? domainAvailability.message || "Tên miền đã được sử dụng."
                    : "Không trùng với tên của cửa hàng khác"}
            </div>
          </Colxx>
        </Row>
        <FormGroup className={"mb-4"}>
          <Label className="has-float-label mt-4">
            <Input
              onChange={onChangeHandleInput}
              name="password"
              id="password"
              defaultValue={values.password}
              type="password"
            />
            <IntlMessages id="user.password" />
          </Label>
          <span className="form-message"></span>
        </FormGroup>
        <div className="d-flex justify-content-end align-items-center">
          <Button
            color="primary"
            className="btn-shadow"
            size="lg"
            onClick={onUserRegister}
          >
            <IntlMessages id="user.register-button" />
          </Button>
        </div>
      </Form>
    </div>
  );

  return (
    <Row className="h-100">
      <Colxx xxs="12" md="10" className="mx-auto my-auto auth-card-pad">
        <Card className="auth-card" autoFocus={false}>
          <div
            className="position-relative image-side "
            style={{
              backgroundImage: `url('${process.env.PUBLIC_URL}/assets/img/login-balloon.jpg')`,
            }}
          >
            <p className="text-white h2">ĐĂNG KÝ</p>
            <p className="white mb-0">
              Điền đầy đủ thông tin để hoàn tất đăng ký.
              <br />
            </p>
          </div>

          {renderRegistrationForm()}
        </Card>
      </Colxx>

      {/* Success Modal */}
      <Modal
        isOpen={showSuccessModal}
        size="md"
        backdrop="static"
        keyboard={false}
      >
        <ModalBody className="text-center py-5">
          <div className="mb-4">
            <i
              className="simple-icon-check"
              style={{ fontSize: "60px", color: "#28a745" }}
            ></i>
          </div>
          <h2 className="mb-3" style={{ color: "#28a745" }}>
            Đăng ký thành công!
          </h2>
          <p className="text-muted mb-4">
            Tài khoản của bạn đã được tạo thành công. <br />
            Bạn sẽ được chuyển đến cửa hàng trong giây lát.
          </p>

          <div
            className="mb-4 p-3"
            style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}
          >
            <p className="mb-1 text-muted small">Địa chỉ cửa hàng của bạn:</p>
            <a
              href={storeUrl}
              className="font-weight-bold"
              style={{ wordBreak: "break-all" }}
            >
              {storeUrl}
            </a>
          </div>

          <div className="mb-4">
            <span className="text-muted">Tự động chuyển hướng sau </span>
            <span
              className="font-weight-bold"
              style={{ fontSize: "24px", color: "#007bff" }}
            >
              {countdown}
            </span>
            <span className="text-muted"> giây</span>
          </div>

          <Button color="primary" size="lg" disabled>
            {/* <div
              className="loading"
              style={{
                width: 16,
                height: 16,
                display: "inline-block",
                marginRight: 8,
                verticalAlign: "middle",
              }}
            /> */}
            Đang đăng nhập...
          </Button>
        </ModalBody>
      </Modal>
    </Row>
  );
};
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(mapStateToProps, {
  registerUser,
})(Register);
